import styled from "@emotion/styled";
import { ComponentType } from "react";
import clsx from "clsx";

export interface HomeComponentProps {
    id: string;
    uniqueClass?: string;
    component: ComponentType<any>;
    props: Record<string, unknown>;
    isFullWidth?: boolean;
    isHero?: boolean;
}

const StyledHomeComponent = styled("div")({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
});

export function HomeComponent(props: HomeComponentProps) {
    const { id, component: Component, props: componentProps, isFullWidth, uniqueClass = "" } = props;

    return (
        <StyledHomeComponent
            className={clsx("kms-ds-homepage-component", `kms-ds-homepage-component-${id}`, uniqueClass)}
        >
            <Component {...componentProps} isFullWidth={isFullWidth} />
        </StyledHomeComponent>
    );
}

export default HomeComponent;
